import React, { useMemo } from 'react'
import { Typography } from '@material-ui/core'
import { useSelector } from 'react-redux'
import Accordion from '_/components/accordion'
import useStyles from './style'
import { currentServiceOrderSelector } from '_/modules/service-orders/selectors'
import FormattedAddress from '_/components/accordion/FormattedAddress'
import { formatPhoneValueRules } from '_/utils/helpers'
import WhatsappNumberLink from '_/components/accordion/WhatsappNumberLink'

export function GeneralDataAccordion() {
  const styles = useStyles()
  const serviceOrderMap = useSelector(currentServiceOrderSelector)
  const serviceOrder = useMemo(() => serviceOrderMap?.toJS(), [serviceOrderMap])

  // Dados do solicitante
  const requesterName = serviceOrder?.contactName || 'Não disponível'
  const applierPhoneNumbers = (serviceOrder?.contactNumbers || []).map(phone =>
    formatPhoneValueRules(phone, '8-14+')
  )

  // Dados da intermediária
  const intermediaryName = serviceOrder?.agency?.name || 'Não disponível'
  const intermediaryResponsible = serviceOrder?.agency?.responsible
  const orderDescription = serviceOrder?.description
  const agencyPhoneNumbers = (serviceOrder?.agency?.phoneNumbers || []).map(phone =>
    formatPhoneValueRules(phone, '8-14+')
  )

  // Dados do imóvel
  const property = serviceOrder?.property || {}
  const googleMapsLink = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
    `${property?.address || ''} ${property?.number || ''} ${property?.city || ''}
     ${property?.uf || ''}`
  )}`

  return (
    <Accordion
      id="general-data"
      title="Dados gerais"
      className={styles.accordion}
      openExpanded={false}
    >
      <div className={styles.details}>
        <div className={styles.detailsColumn}>
          <Typography variant="subtitle2" className={styles.title}>
            Solicitante
          </Typography>
          <Typography variant="body2" className={styles.value}>
            {requesterName}
            <br />
            <WhatsappNumberLink number={applierPhoneNumbers} />
          </Typography>
        </div>
        <div className={styles.detailsColumn}>
          <Typography variant="subtitle2" className={styles.title}>
            Intermediária
          </Typography>
          <Typography variant="body2" className={styles.value}>
            {intermediaryName}
            <br />
            {intermediaryResponsible && (
              <>
                Responsável: {intermediaryResponsible}
                <br />
              </>
            )}
            <WhatsappNumberLink number={agencyPhoneNumbers} />
          </Typography>
        </div>
        <div className={styles.detailsColumn}>
          <Typography variant="subtitle2" className={styles.title}>
            Imóvel
          </Typography>
          <FormattedAddress
            address={property?.address}
            number={property?.number}
            complement={property?.complement}
            neighborhood={property?.neighborhood}
            city={property?.city}
            uf={property?.uf}
            googleMapsLink={googleMapsLink}
          />
        </div>
      </div>
      <div className={styles.details}>
        <div className={styles.descriptionColumn}>
          <Typography variant="subtitle2" className={styles.title}>
            Descrição do chamado
          </Typography>
          <Typography variant="body2" className={styles.value}>
            {orderDescription}
          </Typography>
        </div>
      </div>
    </Accordion>
  )
}
